




import { Vue, Component } from "vue-property-decorator";
import ParticipantsImport from "@share/participants-import/ParticipantsImport.vue";

@Component({ components: { ParticipantsImport } })

export default class ParticipantsImportView extends Vue {}

